import { cnAppConfig } from '@pst/app-config';
import { Reporter } from '@pst/biz';
import $ from 'jquery';
import debounce from 'lodash.debounce';
import { i18n } from './i18n/config';

export const reporter = new Reporter(
  {
    language: 'zh-CN',
    page_text: '',
    web_name: '1',
    region: cnAppConfig.region,
  },
  {
    activityId: 5001,
    title: 'Mistfall Hunter',
  },
);

// @新语言
export enum ClickType {
  WishlistPC = 'WishlistPC',
  WishlistSteam = 'WishlistSteam',
  Steam = 'Steam',
  OfficialPurchase = 'OfficialPurchase',
  OfficialDownload = 'OfficialDownload',
  Weixin = 'Weixin',
  Bilibili = 'Bilibili',
  Douyin = 'Douyin',
  Xiaoheihe = 'Xiaoheihe',
  QQ = 'QQ',
  Tieba = 'Tieba',
  Weibo = 'Weibo',
  PCDownload = 'PCDownload',
  EventButton = 'EventButton',
}

// @新语言
const clickConfig: Record<
  ClickType,
  {
    component_text: string;
    /** 手动递增，已使用的不再使用 */
    component_id: `${number}`;
  }
> = {
  [ClickType.WishlistPC]: {
    component_text: 'homepage_CNlauncher',
    component_id: '1',
  },
  // steam
  [ClickType.WishlistSteam]: {
    component_text: 'homepage_CNsteam',
    component_id: '2',
  },
  [ClickType.Steam]: {
    component_text: 'HNmenu_CNSteam',
    component_id: '3',
  },
  [ClickType.OfficialPurchase]: {
    component_text: 'homepage_CNbuy',
    component_id: '22',
  },
  [ClickType.OfficialDownload]: {
    component_text: 'homepage_CNdownload',
    component_id: '23',
  },
  [ClickType.Weixin]: {
    component_text: 'HNmenu_GZH',
    component_id: '4',
  },
  [ClickType.Bilibili]: {
    component_text: 'HNmenu_Bilbil',
    component_id: '5',
  },
  [ClickType.Douyin]: {
    component_text: 'HNmenu_douyin',
    component_id: '6',
  },
  [ClickType.Xiaoheihe]: {
    component_text: 'HNmenu_XHH',
    component_id: '7',
  },
  [ClickType.QQ]: {
    component_text: 'HNmenu_QQ',
    component_id: '8',
  },
  [ClickType.Tieba]: {
    component_text: 'HNmenu_Tieba',
    component_id: '9',
  },
  [ClickType.Weibo]: {
    component_text: 'HNmenu_Weibo',
    component_id: '10',
  },
  [ClickType.PCDownload]: {
    component_text: '首页-pc端下载',
    component_id: '21',
  },
  [ClickType.EventButton]: {
    component_text: '点击猎金狂潮',
    component_id: '24',
  },
};

export const reportEvents = {
  sendWhileLaunch() {
    const currentDate = Date.now();

    reporter.sendEvent('web_pageview', {
      page_text: i18n.documentTitle,
    });

    $(() => {
      reporter.sendEvent('web_pageload', {
        page_text: i18n.documentTitle,
        duration: Date.now() - currentDate,
      });

      let maxViewProportion = 0;
      const getScrollPercentage = () => {
        const container = document.documentElement;
        return Number(
          ((100 * (container.scrollTop + window.innerHeight)) / container.scrollHeight).toFixed(1),
        );
      };
      const report = () => {
        maxViewProportion = Math.max(maxViewProportion, getScrollPercentage());
        reporter.sendEvent('web_pagebrowse', {
          duration_since_start: Date.now() - currentDate,
          view_proportion: String(maxViewProportion),
        });
      };
      report();
      // setInterval(report, 3000);
      const scrollListener = debounce(report, 500);
      window.addEventListener('scroll', scrollListener);
      window.addEventListener('unload', () => {
        window.removeEventListener('scroll', scrollListener);
      });
    });
  },

  sendBtnClick(type: ClickType) {
    const ids = Object.values(clickConfig).map((i) => i.component_id);
    if (new Set(ids).size !== ids.length) {
      console.error('duplicate id');
      // throw new Error('id重复');
    }

    const context = clickConfig[type];
    if (!context) {
      console.error('unknown event');
      return;
    }

    const teaData = context;

    console.log('event:', context.component_id);
    console.log('event:', context);

    reporter.sendEvent('web_button_touch', {
      ...teaData,
      page_text: i18n.documentTitle,
      component_name: '',
    });
  },
};
